import React, { Component } from 'react'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { Link } from "react-router-dom"

import logo from "../../assets/images/logo.svg"

class MobileHeader extends Component {
    render() {
        const { toggleMobileHeader, openMobileHeader } = this.props;
        return (
            <div
                id="overlay2"
                style={{ display: openMobileHeader ? "block" : "none" }}>
                <div id="overlay2_header">
                    <Link to="/">
                        <img alt="HendrayFinvest logo" src={logo} />
                    </Link>
                    <HighlightOffIcon onClick={toggleMobileHeader} id="close_img" />
                </div>
                <div id="overlay2_menu1">
                    <ul id="overlay2_menu1_ul">
                        <li><Link to="/"><p className="main-color light">Home</p></Link></li>
                        <li><Link to="/academy"><p className="main-color light">Academy</p></Link></li>
                        <li><Link to="/about"><p className="main-color light">About Us</p></Link></li>
                        <li><Link to="/"><p className="main-color light">Contact Us</p></Link></li>
                        <li>
                            <a href="https://user-hendrayfinvest.netlify.app">
                                <p className="main-color light">Login</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default MobileHeader;